/* Pop-up de bienvenida · LEVIOHOME */
(function () {
  var dlg = document.getElementById('lv-bienvenida');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var DELAY = (parseInt(dlg.dataset.delay, 10) || 5) * 1000;
  var DAYS = parseInt(dlg.dataset.days, 10) || 7;
  var K_CLOSED = 'lv_bienvenida_cerrado';
  var K_SEEN = 'lv_bienvenida_visto';
  var K_START = 'lv_sesion_inicio';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function get(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return null;
    }
  }
  function set(store, key, val) {
    try {
      window[store].setItem(key, val);
    } catch (e) {}
  }

  var interacted = false;
  var purchaseTouched = false;
  var timer = null;
  var tries = 0;

  function closedRecently() {
    var t = parseInt(get('localStorage', K_CLOSED), 10);
    return t && Date.now() - t < DAYS * 86400000;
  }

  // Interacciones de compra: variantes, cantidad, añadir al carrito, carrito, buscador…
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('product-form, form[action*="/cart/add"], cart-drawer, cart-notification, .cart-notification, a[href*="/cart"]')) {
        purchaseTouched = true;
      }
    },
    true
  );
  document.addEventListener(
    'change',
    function (e) {
      if (e.target.closest && e.target.closest('variant-selects, product-form, form[action*="/cart/add"]')) {
        purchaseTouched = true;
      }
    },
    true
  );

  ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'].forEach(function (ev) {
    window.addEventListener(
      ev,
      function () {
        interacted = true;
      },
      { passive: true, once: true }
    );
  });

  function blocked() {
    if (document.visibilityState !== 'visible') return true;
    if (!interacted) return true;
    if (purchaseTouched) return true;
    if (document.querySelector('dialog[open]:not(#lv-bienvenida), details[open] > summary + .menu-drawer, details-modal[open], details[open].menu-opening')) return true;
    if (document.querySelector('cart-drawer.active, .cart-notification.active, #cart-notification.active')) return true;
    return false;
  }

  function open() {
    if (dlg.open) return;
    set('sessionStorage', K_SEEN, '1');
    dlg.showModal();
    document.documentElement.classList.add('lv-pop-open');
  }

  function close(remember) {
    if (remember !== false) set('localStorage', K_CLOSED, String(Date.now()));
    if (dlg.open) dlg.close();
  }

  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('lv-pop-open');
  });
  dlg.addEventListener('cancel', function () {
    set('localStorage', K_CLOSED, String(Date.now()));
  });
  dlg.addEventListener('click', function (e) {
    // clic en el fondo oscurecido
    if (e.target === dlg) close();
    var c = e.target.closest && e.target.closest('[data-lv-close]');
    if (c) close();
    if (e.target.closest && e.target.closest('[data-lv-accept]')) {
      set('localStorage', K_CLOSED, String(Date.now()));
    }
  });

  function attempt() {
    if (!blocked()) return open();
    if (++tries < 40) timer = setTimeout(attempt, 1500);
  }

  if (designMode) {
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === dlg.dataset.sectionId) open();
    });
    document.addEventListener('shopify:section:deselect', function () {
      close(false);
    });
    return;
  }

  if (get('sessionStorage', K_SEEN) || closedRecently()) return;

  var start = parseInt(get('sessionStorage', K_START), 10);
  if (!start) {
    start = Date.now();
    set('sessionStorage', K_START, String(start));
  }
  var wait = Math.max(0, DELAY - (Date.now() - start));
  timer = setTimeout(attempt, wait);
})();
